document.addEventListener('DOMContentLoaded', function () {
  const searchResults = document.querySelector('.search-results__results');
  const productsResultsList = document.querySelector(
    '.search-results__products-list'
  );
  const eventsResultsList = document.querySelector(
    '.search-results__events-list'
  );
  const emptySearch = document.querySelector('.search-results__empty-search');
  const emptySearchState = document.querySelector('.search-results__empty');
  const searchIcon = document.querySelector('.search-drawer__search-icon');
  const suggestionButtons = document.querySelectorAll(
    '.search-results__suggestion-link'
  );
  const ourServices = document.querySelector('.search-drawer__our-services');

  const searchButton = document.getElementById('header-search-button');
  const searchButtonMobile = document.querySelector(
    '.mobile-header__search-button'
  );
  const searchDrawerCloseButton = document.getElementById(
    'search-drawer-close-button'
  );

  const clearButton = document.querySelector('.search-drawer__clear-button');
  const emptyResetButton = document.querySelector(
    '.search-results__empty-reset'
  );

  const searchDrawer = document.querySelector('.search-drawer');

  const searchForm = document.querySelector('.search-drawer__search-form');
  const searchInput = document.querySelector('.search-drawer__search-input');

  const searchResultProducts = searchDrawer.querySelector(
    '.search-results__products-count'
  );
  const searchResultEvents = searchDrawer.querySelector(
    '.search-results__events-count'
  );

  const searchResultProductsLink = searchDrawer.querySelector(
    '.search-results__open-all-products'
  );
  const searchResultEventsLink = searchDrawer.querySelector(
    '.search-results__open-all-events'
  );

  const resetData = () => {
    searchInput.value = '';
    searchResults.classList.add('search-results--results-hidden');
    productsResultsList.innerHTML = '';
    eventsResultsList.innerHTML = '';
    emptySearch.style.display = 'block';

    searchIcon?.classList.remove('search-drawer__search-icon--active');
    clearButton.classList.add('search-drawer__clear-button--hidden');
    searchDrawerCloseButton.classList.remove(
      'search-drawer__close-button--hidden'
    );
    ourServices?.classList.remove('search-drawer__our-services--hidden');
  };

  let debounceTimeout;

  if (searchForm) {
    searchForm.addEventListener('submit', function (event) {
      event.preventDefault();
    });

    searchForm.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    });
  }

  searchButton?.addEventListener('click', function () {
    if (searchDrawer) {
      searchDrawer.classList.remove('search-drawer--mobile-open');
      searchDrawer.classList.add('search-drawer--desktop-open');
      document.body.classList.add('page--scroll-lock');

      resetData();
      setTimeout(() => {
        searchInput?.focus();
      }, 100);
    }
  });

  searchButtonMobile?.addEventListener('click', function () {
    if (searchDrawer) {
      searchDrawer.classList.remove('search-drawer--desktop-open');
      searchDrawer.classList.toggle('search-drawer--mobile-open');
      document.body.classList.toggle('page--scroll-lock');

      resetData();
      setTimeout(() => {
        searchInput?.focus();
      }, 100);
    }
  });

  const resetSearch = () => {
    searchInput.value = '';
    searchResults.classList.add('search-results--results-hidden');
    productsResultsList.innerHTML = '';
    emptySearch.style.display = 'block';
    emptySearchState.style.display = 'none';

    searchIcon?.classList.remove('search-drawer__search-icon--active');
    clearButton.classList.add('search-drawer__clear-button--hidden');
    searchDrawerCloseButton.classList.remove(
      'search-drawer__close-button--hidden'
    );
    ourServices?.classList.remove('search-drawer__our-services--hidden');

    searchInput.focus();
  };

  clearButton?.addEventListener('click', resetSearch);
  emptyResetButton?.addEventListener('click', resetSearch);

  searchDrawerCloseButton?.addEventListener('click', function () {
    const searchDrawer = document.querySelector('.search-drawer');
    if (searchDrawer) {
      searchDrawer.classList.remove(
        'search-drawer--mobile-open',
        'search-drawer--desktop-open'
      );
      document.body.classList.remove('page--scroll-lock');
    }
  });

  searchInput.addEventListener('input', function () {
    const query = this.value.trim();

    if (query.length < 1) {
      clearButton.classList.add('search-drawer__clear-button--hidden');
    }

    clearTimeout(debounceTimeout);
    if (query.length < 2) {
      productsResultsList.innerHTML = '';
      searchResults.classList.add('search-results--results-hidden');
      emptySearch.style.display = 'block';
      if (searchIcon) {
        searchIcon.classList.remove('search-drawer__search-icon--active');
        ourServices?.classList.remove('search-drawer__our-services--hidden');
      }
      return;
    }

    clearButton.classList.remove('search-drawer__clear-button--hidden');
    searchDrawerCloseButton.classList.add(
      'search-drawer__close-button--hidden'
    );

    if (searchIcon) {
      searchIcon.classList.add('search-drawer__search-icon--active');
    }

    debounceTimeout = setTimeout(() => {
      fetch(`/search?q=${encodeURIComponent(query)}&type=product,article`)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          let newResults = doc.querySelector('#products-search-results');

          const productsResultsList = document.querySelector(
            '#products-search-results'
          );
          productsResultsList.innerHTML = newResults.innerHTML;

          newResults = doc.querySelector('#events-search-results');
          const eventsResultsList = document.querySelector(
            '#events-search-results'
          );
          eventsResultsList.innerHTML = newResults.innerHTML;

          const products = doc.querySelectorAll(
            '#products-search-results .search-results__products-item'
          );
          const articles = doc.querySelectorAll(
            '#events-search-results .search-results__events-item'
          );
          const haveResults = products.length > 0 || articles.length > 0;
          console.log(articles);

          if (!haveResults) {
            searchResults.classList.add('search-results--results-hidden');
            emptySearch.style.display = 'none';
            ourServices?.classList.add('search-drawer__our-services--hidden');
            emptySearchState.style.display = 'flex';
          } else {
            const searchProductsType =
              products.length > 0 ? 'product' : 'article,product';
            const searchArticlesType =
              articles.length > 0 ? 'article,product' : 'product';
            emptySearchState.style.display = 'none';
            searchResults.classList.remove('search-results--results-hidden');
            searchResultProducts.textContent = products.length;
            searchResultProductsLink.href = `/search?q=${encodeURIComponent(
              query
            )}&type=${searchProductsType}&sort_by=relevance&articles=${
              articles.length
            }&products=${products.length}`;
            searchResultEvents.textContent = articles.length;
            searchResultEventsLink.href = `/search?q=${encodeURIComponent(
              query
            )}&type=${searchArticlesType}&sort_by=relevance&articles=${
              articles.length
            }&products=${products.length}`;
            ourServices?.classList.add('search-drawer__our-services--hidden');
            emptySearch.style.display = 'none';
          }
        });
    }, 500);
  });

  suggestionButtons.forEach((button) => {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      const suggestion = this.textContent.trim();
      searchInput.value = suggestion;
      searchInput.dispatchEvent(new Event('input'));
    });
  });

  // Close search drawer on Escape key press
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      searchDrawer.classList.remove(
        'search-drawer--mobile-open',
        'search-drawer--desktop-open'
      );
      document.body.classList.remove('page--scroll-lock');
    }
  });

  // Close search drawer when clicking outside of it
  document.addEventListener('click', function (event) {
    const isClickInside = searchDrawer.contains(event.target);
    const isSearchButton =
      searchButton?.contains(event.target) ||
      searchButtonMobile?.contains(event.target);
    if (
      !isClickInside &&
      !isSearchButton &&
      searchDrawer.classList.contains('search-drawer--desktop-open')
    ) {
      searchDrawer.classList.remove('search-drawer--desktop-open');
      document.body.classList.remove('page--scroll-lock');
    }
    if (
      !isClickInside &&
      !isSearchButton &&
      searchDrawer.classList.contains('search-drawer--mobile-open')
    ) {
      searchDrawer.classList.remove('search-drawer--mobile-open');
      document.body.classList.remove('page--scroll-lock');
    }
  });
});
